import {
  Certificate,
  OrganisationRegistrant,
} from "../../../../../types/registration";
import { Action } from "../actions";
import { RegistrationStatus, UserInput } from "./org-actions";

type OrgState = {
  data?: OrganisationRegistrant;
  solvencyOK: boolean;
  hasOrgs: boolean;
  userInput: UserInput;
  registrationStatus: RegistrationStatus;
  digipostaddress?: string;
  senderId?: string;
  existing?: boolean;
  certificate: Certificate;
  organisationNumber?: string;
};

const initialState: OrgState = {
  data: undefined,
  solvencyOK: false,
  hasOrgs: false,
  userInput: {
    email: "",
    phone: "",
    selectedOrganisationNumber: "",
    mailbox: false,
    showPartnerChoice: false,
    selectedIntegrationPartner: undefined,
  },
  registrationStatus: RegistrationStatus.NONE,
  certificate: {
    certificates: [],
    link: [],
  },
};

export default function orgReducer(
  state: OrgState = initialState,
  action: Action,
): OrgState {
  switch (action.type) {
    case "ORGANISATIONS_FETCHED": {
      const { org, preselectedOrg, selectedIntegrationPartner } = action;
      const orgs = org.registrableOrganisations;

      return {
        ...state,
        data: org,
        solvencyOK: org.solvencyStatus === "OK",
        hasOrgs: orgs.length > 0,
        userInput: {
          ...state.userInput,
          ...(action.behandlerFlow ? { selectedIntegrationPartner } : {}),
          ...(orgs.length === 1 && orgs[0].registrationStatus === "REGISTRABLE"
            ? { selectedOrganisationNumber: orgs[0].organisationNumber }
            : {}),
          ...(preselectedOrg
            ? { selectedOrganisationNumber: preselectedOrg.organisationNumber }
            : {}),
        },
      };
    }
    case "SET_CONTROL_FLOW": {
      return {
        ...state,
        userInput: {
          ...state.userInput,
          mailbox: action.payload.mode === "bedrift",
        },
      };
    }
    case "SET_USER_INPUT":
      return {
        ...state,
        userInput: {
          ...state.userInput,
          ...action.userInput,
        },
      };
    case "SET_REGISTRATION_STATUS":
      return {
        ...state,
        registrationStatus: action.registrationStatus,
      };
    case "INTEGRATION_PARTNER_REGISTERED":
      return {
        ...state,
        digipostaddress: action.digipostaddress,
        senderId: action.senderId,
        organisationNumber: action.organisationNumber,
        existing: action.existing,
      };

    case "CERTIFICATE_FETCHED":
      return {
        ...state,
        certificate: action.certificate,
      };
    default:
      return state;
  }
}
